var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5026 15.8333C12.8749 15.8333 16.4193 12.2889 16.4193 7.91667C16.4193 3.54441 12.8749 0 8.5026 0C4.13035 0 0.585938 3.54441 0.585938 7.91667C0.585938 12.2889 4.13035 15.8333 8.5026 15.8333Z",
    fill: "#11385B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8143 11.1467C10.7101 11.1473 10.6068 11.1273 10.5103 11.0879C10.4139 11.0485 10.3262 10.9905 10.2522 10.9171L7.94052 8.5975C7.79427 8.45004 7.71181 8.25102 7.71094 8.04333V3.16667C7.71094 2.9567 7.79435 2.75534 7.94281 2.60687C8.09128 2.45841 8.29264 2.375 8.5026 2.375C8.71257 2.375 8.91393 2.45841 9.0624 2.60687C9.21086 2.75534 9.29427 2.9567 9.29427 3.16667V7.71083L11.3764 9.79292C11.4506 9.86651 11.5095 9.95407 11.5496 10.0505C11.5898 10.147 11.6105 10.2505 11.6105 10.355C11.6105 10.4595 11.5898 10.563 11.5496 10.6595C11.5095 10.7559 11.4506 10.8435 11.3764 10.9171C11.3024 10.9905 11.2147 11.0485 11.1182 11.0879C11.0217 11.1273 10.9185 11.1473 10.8143 11.1467Z",
    fill: "#EDEBEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingIcon);
export default __webpack_public_path__ + "static/media/pending-icon.9285b3fa02853376e3ddb2f5260eed3b.svg";
export { ForwardRef as ReactComponent };